import { connect } from 'react-redux'
import TwilioDocSupportScreen from './TwilioDocSupportScreen'
import { State } from '../../dataStore/reducers/reducerType'
import { resetUIDocGoingLiveFlag, setBookingStatus } from '../../dataStore/actions/room/room'

const mapStateToProps = (state: State, props) => ({
  ...props,
  isGoingLive: state.ui.goingLive,
  liveDateTime: state.ui.liveDateTime,
  mediaType: state.room.mediaType,
  status: state.ui.status
})

const mapDispatchToProps = (dispatch) => ({
  resetGoingLive: () => dispatch(resetUIDocGoingLiveFlag()),
  setBookingStatus: (status) => dispatch(setBookingStatus(status))
})

export default connect(mapStateToProps, mapDispatchToProps)(TwilioDocSupportScreen)
